import React from 'react'
import { SecondaryLightBtn } from '../components'

const Sliders = () => {
  return ( 
    <div className='page'>
      <h1>Sliders</h1>
      <p className='page__desc'>Website for analysis of data by stakeholders like government officials, researchers, and policy makers (for creating insurance programs)</p>
      <div>
      <SecondaryLightBtn>Ethiopia Sliders →</SecondaryLightBtn>
      <SecondaryLightBtn>Nigeria Sliders →</SecondaryLightBtn>
      </div>
    </div>
  )
}

export default Sliders
